import { render, staticRenderFns } from "./RingQuickView.vue?vue&type=template&id=f4321448&scoped=true&"
import script from "./RingQuickView.vue?vue&type=script&lang=js&"
export * from "./RingQuickView.vue?vue&type=script&lang=js&"
import style0 from "./RingQuickView.vue?vue&type=style&index=0&id=f4321448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4321448",
  null
  
)

export default component.exports